import styled, { css } from 'styled-components';

export const StyledModalLoader = styled.div`
  min-height: ${({ minHeight }) => minHeight ?? '400px'};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 460px;
}
`;

export const StyledDepositBonus = styled.div`
  display: flex;
  align-items: center;  
  justify-content: space-between;  
  margin-top: 15px;
  p {
    font-size: 14px;
    span {
        color: ${({ theme }) => theme.subTitleColor};
        font-weight: 500;
    }    
  }  
`;

export const StyledHelpElement = styled.div`
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.neutralColor};
    border-radius: 100%;
    font-size: 16px;
    color: ${({ theme }) => theme.tokens.notificationAmountToken.iconColor};
    cursor: pointer;
    margin-left: 7px;
    transition: background-color 0.2s ease;
    
    .help-el__text {
        display: none;
        position: absolute;
        right: 0;
        top: 0;
        width: 250px;
        padding: 10px;
        background: ${({ theme }) => theme.neutralColor};
        font-size: 12px;
        transition: background-color 0.2s ease;
    }

    &:hover {
        background: ${({ theme }) => theme.neutralColorHover};
        .help-el__text {
            display: block;
            background: ${({ theme }) => theme.neutralColorHover};
        }
    }
`

export const StyledQrCodeWrapper = styled.div`
  position: relative;
  overflow: hidden;
  transition: height 0.4s ease;
  height: ${({ isOpen }) => (isOpen ? '260px' : '45px')};
`;

export const StyledQrCodeToggler = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 10px 15px;
    background-color: ${({theme}) => theme.twoFa.codeBg};
    border-radius: 3px;
    user-select: none;
    z-index: 1;
    position: relative;
`;

export const StyledQrCodeTogglerTitle = styled.div`
    font-size: 14px;
    color: ${({ theme }) => theme.textColor};
`;

export const StyledQrCodeTogglerArrow = styled.div`
  font-size: 12px;
  transition: transform 0.3s ease;
  ${({ isOpen }) =>
    isOpen
        ? css`
          transform: rotate(180deg);
        `
        : css`
          transform: rotate(0deg);
        `}
`;

export const StyledQrCode = styled.div`
  position: absolute;
  top: ${({ isOpen }) => (isOpen ? '35px' : '-260px')};
  left: 0;
  width: 100%;
  transition: top 0.4s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.twoFa.codeBg};
  border-radius: 3px;
  padding: 20px 0;
`;